import {
  alpha,
  Box,
  Button,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import { Person, Logout } from "@mui/icons-material";
import HamberMenu from "./HamberMenu";
import ImgBox from "../../../Components/ImgBox";
import Searchbar from "./Searchbar";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../Store/Slices/userSlice";
export default function Navbar() {
  const { token } = useSelector((state) => state?.userSlice);
  const dispatch = useDispatch();
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation().pathname;
  const itemRefs = useRef([]);
  const containerRef = useRef(null);
  const isSmall = useMediaQuery("(max-width:900px)");

  const [openHameber, setOpenHamber] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [paintPosition, setPaintPosition] = useState(0);

  const [isNavbarVisible, setIsNavbarVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const [openSearchbar, setOpenSearchbar] = useState(false);

  const navbarItems = [
    {
      title: "صفحه اصلی",
      route: "/",
    },
    {
      title: "باشگاه ها",
      route: "/gyms",
    },
    {
      title: "مربیان",
      route: "/coaches",
    },
    {
      title: "همکاری",
      route: "/cooperation",
    },
    // {
    //   title: "مقالات",
    //   route: "/blogs",
    // },
    {
      title: "درباره آدین زون",
      route: "/about-us",
    },
  ];

  // Effect Scroll
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      // down Scroll
      if (currentScrollY > lastScrollY && currentScrollY > 100) {
        setIsNavbarVisible(false);
      }
      // top Scroll
      else if (currentScrollY < lastScrollY) {
        setIsNavbarVisible(true);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [lastScrollY]);

  // Update active index when location changes
  useEffect(() => {
    const currentIndex = navbarItems.findIndex(
      (item) => item.route === location,
    );
    if (currentIndex !== -1) {
      setActiveIndex(currentIndex);
    }
  }, [location]);

  // Update paint position when active index changes or on resize
  useEffect(() => {
    const updatePaintPosition = () => {
      if (itemRefs.current[activeIndex] && containerRef.current) {
        const activeItem = itemRefs.current[activeIndex];
        const containerRect = containerRef.current.getBoundingClientRect();
        const activeItemRect = activeItem.getBoundingClientRect();
        const itemCenter =
          activeItemRect.left - containerRect.left + activeItemRect.width / 2;
        const paintLeft = itemCenter - 25;
        setPaintPosition(paintLeft);
      }
    };
    updatePaintPosition();
  }, [activeIndex]);

  const items = navbarItems?.map((item, index) => {
    const isSelected = location == item?.route;
    return (
      <Button
        key={index}
        ref={(el) => (itemRefs.current[index] = el)}
        direction={"row"}
        onClick={() => {
          navigate(item?.route);
          setOpenHamber(false);
        }}
        sx={{
          py: ".5rem",
          transition: "all .2s",
          textAlign: "center",
          fontWeight: isSelected ? "bold" : "normal",
          fontSize: { xs: ".8rem", lg: ".9rem" },
          justifyContent: "space-between",
          alignItems: "center",
          cursor: "pointer",
          position: "relative",
          px: "4px",
          minWidth: "0",
          color: isSelected
            ? theme.palette.primary.main
            : theme.palette.text.primary,
          ":hover": {
            color: "primary.light",
            bgcolor: "transparent !important",
          },
        }}
      >
        {item?.title}
      </Button>
    );
  });

  return (
    <>
      <Stack
        sx={{
          position: "fixed",
          zIndex: "100000",
          top: "0",
          left: "0",
          right: "0",
          width: "100%",
          alignItems: "center",
          px: "1.5rem",
          transform: isNavbarVisible ? "translateY(0)" : "translateY(-100%)",
          transition: "all 0.3s ease-in-out",
        }}
      >
        <Stack
          ref={containerRef}
          direction={"row"}
          sx={{
            justifyContent: "space-between",
            width: "100%",
            height: { xs: "54px", sm: "64px", lg: "74px", xxl: "84px" },
            mt: "1.3rem",
            px: { xs: "1rem", lg: "2rem" },
            py: "1rem",
            borderRadius: "1.3rem",
            // borderBottomRightRadius: "0",
            bgcolor: alpha(theme.palette.background.paper, 0.55),
            alignItems: "center",
            position: "relative",
            maxWidth: "1400px",
            border: "1px solid lightGray",
            backdropFilter: "blur(.5rem)",
          }}
        >
          {/* Logo */}
          <ImgBox
            onClick={() => navigate("/")}
            sx={{
              cursor: "pointer",
              width: { xs: "100px", sm: "120px", lg: "90px", xl: "170px" },
              zIndex: "100",
            }}
            alt="adinZone.png"
            src="/media/global/adinZone.svg"
          />

          {/* Navbar Items */}
          <Stack
            sx={{
              gap: { xs: "12px", lg: "16px" },
              display: { xs: "none", md: "flex" },
              width: { xs: "calc(100% - 100px)", lg: "calc(100% - 200px)" },
              justifyContent: "center",
            }}
            direction={"row"}
          >
            {items}
          </Stack>

          {/* Login Btn */}
          <Button
            aria-label="login button"
            color="primary"
            variant="contained"
            onClick={() => {
              token ? dispatch(logout()) : navigate("/auth");
            }}
            sx={{
              fontSize: ".8rem",
              px: { xs: "8px", xl: "1rem" },
              py: "6px",
              borderRadius: "1rem",
              fontWeight: "normal",
              display: { xs: "none", md: "flex" },
              width: { xs: "max-content", xl: "150px" },
              minWidth: "0",
              gap: "4px",
            }}
          >
            {isSmall ? (
              <>{token ? <Logout /> : <Person />}</>
            ) : (
              <>
                {token ? (
                  <>
                    <Logout fontSize="small" /> خروج
                  </>
                ) : (
                  <>
                    <Person fontSize="small" /> ورود / ثبت نام
                  </>
                )}
              </>
            )}
          </Button>

          {/* Hamber Btn */}
          <IconButton
            sx={{ display: { xs: "flex", md: "none" } }}
            color="primary"
          >
            <MenuIcon
              onClick={() => setOpenHamber(true)}
              sx={{
                color: theme.palette.primary.main,
                fontSize: "2rem",
              }}
            />
          </IconButton>

          {/* Search and Close Icon */}
          {/* <Box
            sx={{
              position: "absolute",
              top: "calc(100%)",
              right: "0",
            }}
          >
            <IconButton
              onClick={() => setOpenSearchbar((prev) => !prev)}
              sx={{
                bgcolor: theme.palette.background.lowOpacity,
                borderRadius: "0",
                borderBottomLeftRadius: "16px",
                borderBottomRightRadius: "16px",
                color: theme.palette.primary.main,
                position: "relative",
                width: { xs: "35px", sm: "45px" },
                height: { xs: "30px", sm: "40px" },
                border: "1px solid lightGray",
                borderTop: "none",
                zIndex: "10",
              }}
            >
              <Search
                sx={{
                  visibility: openSearchbar ? "hidden" : "visible",
                  opacity: openSearchbar ? "0" : "1",
                  position: "absolute",
                  transform: openSearchbar ? "rotate(-360deg)" : "rotate(0)",
                  transition: "all .5s",
                }}
              />
              <Close
                sx={{
                  visibility: !openSearchbar ? "hidden" : "visible",
                  opacity: !openSearchbar ? "0" : "1",
                  position: "absolute",
                  transform: !openSearchbar ? "rotate(360deg)" : "rotate(0)",
                  transition: "all .5s",
                }}
                color="error"
              />
            </IconButton>
          </Box> */}
        </Stack>
        {/* Search Section */}
        <Searchbar
          open={openSearchbar}
          handleClose={() => setOpenSearchbar(false)}
        />
      </Stack>
      <HamberMenu
        open={openHameber}
        handleClose={() => setOpenHamber(false)}
        items={items}
        token={token}
      />
      <Stack sx={{ mt: { xs: "70px", md: "80px", lg: "100px" } }} />
    </>
  );
}
